import { render } from "./BrinkThree.vue?vue&type=template&id=ded14b48"
import script from "./BrinkThree.vue?vue&type=script&lang=js"
export * from "./BrinkThree.vue?vue&type=script&lang=js"

import "./BrinkThree.vue?vue&type=style&index=0&id=ded14b48&lang=css"
script.render = render

export default script